export const PRIVACY_BY_DESIGN_TUTORIAL_STEP_1 =
  'privacy-by-design-tutorial-step-1'
export const PRIVACY_BY_DESIGN_TUTORIAL_STEP_2 =
  'privacy-by-design-tutorial-step-2'
export const PRIVACY_BY_DESIGN_TUTORIAL_STEP_3 =
  'privacy-by-design-tutorial-step-3'
export const PRIVACY_BY_DESIGN_TUTORIAL_STEP_4 =
  'privacy-by-design-tutorial-step-4'
export const PRIVACY_BY_DESIGN_TUTORIAL_STEP_5 =
  'privacy-by-design-tutorial-step-5'

export const privacyByDesignTutorialSteps = [
  {
    element: '#' + PRIVACY_BY_DESIGN_TUTORIAL_STEP_1,
    popover: {
      title: 'Bem-vindo ao Privacy by Design',
      description:
        'Aqui você acompanha todos os projetos enviados para análise de privacidade. Use este tutorial sempre que precisar relembrar como utilizar a tela.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_TUTORIAL_STEP_2,
    popover: {
      title: 'Criar um novo projeto',
      description:
        'Clique em Criar para iniciar um novo projeto de Privacy by Design e enviar para avaliação.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_TUTORIAL_STEP_3,
    popover: {
      title: 'Filtrar por status',
      description:
        'Utilize as abas para visualizar projetos por status: pendente, aguardando revisão, aprovado, reprovado, risco assumido e inativo.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_TUTORIAL_STEP_4,
    popover: {
      title: 'Pesquisar projetos',
      description:
        'Pesquise rapidamente pelo nome do projeto para localizar o registro que precisa.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_TUTORIAL_STEP_5,
    popover: {
      title: 'Acompanhar e gerenciar',
      description:
        'Acompanhe ID, nome, departamento, última alteração, template e status do projeto. Use o menu de ações para visualizar, editar ou excluir.',
    },
  },
]
